/* eslint-disable prettier/prettier */
import { Box, Button, Drawer, InputBase, makeStyles } from '@material-ui/core'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { setSelectedChat } from 'src/store/actions/chatActions'
import { API_URL, JWT_TOKEN } from '../../config'
import Conversation from './Conversation'
import UserListItem from './UserListItem'



const useStyles = makeStyles({
  header:{
    background:'#f4bb44',
    color:'white',
    height:50,
    padding:10,
    fontWeight:'bold',
    fontSize:20,
    borderTopLeftRadius:'10px',
  },
  component: {
    marginLeft:'10px',
    overflowY:'scroll',
    position:'relative',
    height: '450px'
   
},
  search:{
    height:'55px',
    background:'rgba(245,241,241)',
    borderRadius:'10px',
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center',
    padding:'0 15px'

  },
})

const MyChats = () => {
  const classes = useStyles()
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const dispatch = useDispatch();
  const [search,setSearch] = useState('')
  const chats = useSelector(state => state.chats.chats);
  const login = useSelector(state => state.login);
  const selectedChat = useSelector(state => state.selectedChat.data)

  
  const [searchResult, setSearchResult] = useState();
  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const handleSearch = async() =>{
    if(!search){
      toast.error('Please enter something in search', {
        position: 'top-center',
        autoClose: 5000,
        pauseOnHover: false,
      })
    }
    try {
      
      const config = {
        headers:{ 'X-Auth-Token': JWT_TOKEN},
        params :{ user : search}
      }
      const res = await axios.get(API_URL.fetch_user_api,config)
      console.log("Handle search",res.data.message);
      if(res.data.status){
          setSearchResult(res.data.message)
      }else{
        toast.error('Enter correct username', {
          position: 'top-center',
          autoClose: 5000,
          pauseOnHover: false,
        })
      }
     
    } catch (error) {
      toast.error('Error occured', {
        position: 'top-center',
        autoClose: 5000,
        pauseOnHover: false,
      })
    }
  }

  const accessChat = async(userId) =>{
   try {
    const config = {
      headers:{ 'X-Auth-Token': JWT_TOKEN},
      params:{ id : userId}
    }

    const res = await axios.post(API_URL.access_chat_api,config)
   console.log("Access chat",res.data);
    dispatch(setSelectedChat(res.data))
   } catch (error) {
     
   }
  }


  
 


  useEffect(()=>{
   
  },[])


  return (
    <Box>
      <Box className={classes.header}><Button onClick={toggleDrawer('left',true)}>Search Users</Button>
      <Drawer
            className={classes.drawer}
            anchor={'left'}
            open={state['left']}
            onClose={toggleDrawer('left', false)}
          >
          <Box className={classes.search}>
          <InputBase 
            placeholder="Enter username"
            value={search}
            onChange={(e)=> setSearch(e.target.value)}
            />
          <Button onClick={handleSearch}>Search</Button>
          </Box>
     
          {searchResult && 
            <UserListItem
              key={searchResult._id}
              user={searchResult}
              handleFunction = {()=> accessChat(searchResult._id)}
            />
          }
          </Drawer>
      </Box>
 
{/* {console.log("SELECTED CHA",selectedChat)} */}
      <Box className={classes.component}>
     {chats && chats.map(chat =>(
      <Box  key={chat._id} onClick={()=> dispatch(setSelectedChat(chat))}>
      <Conversation
          own={selectedChat._id === chat._id}
          user= {chat.users[0].username === login.data.username ?(chat.users[1]? chat.users[1].username : "NO"): chat.users[0].username} />
      </Box>
   
     ))}
   
      </Box>

    </Box>
  )
}

export default MyChats
